import { IApplicationData } from "../../../model/application-data";
import { IParametersPortalReponse } from "../../../model/base/response/parameters-portal-response";
import { IMenuResponse } from "../../../model/base/response/menu-response";
import { IPortalHomeResponse } from "../../../model/base/response/portal-home-response";


export type GobalState = {
    applicationData: IApplicationData | undefined;
    parametersPortal: IParametersPortalReponse | undefined;
    menus: IMenuResponse[] | undefined;
    /** Customização da home (APM), carregada junto com o portal. */
    portalHome: IPortalHomeResponse | undefined;
    error: { statusCode?: number; message: string } | null;
};

export enum ACTION_TYPES {
    setApplicationData = 'setApplicationData',
    setParametersPortal = 'setParametersPortal',
    setMenus = 'setMenus',
    setPortalHome = 'setPortalHome',
    setError = 'setError',
}

export const GlobalReducer = (state: GobalState, action: any): GobalState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setApplicationData:
            return {
                ...state,
                applicationData: payload,
                error: null,
            };
        case ACTION_TYPES.setParametersPortal:
            return {
                ...state,
                parametersPortal: payload,
                error: null,
            };
        case ACTION_TYPES.setMenus:
            return {
                ...state,
                menus: payload,
                error: null,
            };
        case ACTION_TYPES.setPortalHome:
            return {
                ...state,
                portalHome: payload,
            };
        case ACTION_TYPES.setError:
            return {
                ...state,
                error: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}